import React, { FC } from 'react';
import { AutumnColors } from './autumnColors';

export interface AutumnPumpkinProps {
  /** Height of the pumpkin in px. Width follows the aspect ratio. */
  size?: number;
  /** Shows a carved, glowing jack-o'-lantern face. */
  lit?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/** A small hand-drawn SVG pumpkin. */
export const AutumnPumpkin: FC<AutumnPumpkinProps> = ({ size = 28, lit = false, className, style }) => {
  const width = Math.round(size * 1.15);
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={size}
      viewBox='0 0 46 40'
      role='img'
      aria-hidden='true'
      data-testid='AutumnPumpkin'
      data-lit={lit ? 'true' : 'false'}>
      <defs>
        <radialGradient id='autumnPumpkinGlow' cx='50%' cy='55%' r='55%'>
          <stop offset='0%' stopColor={AutumnColors.GLOW} stopOpacity='0.95' />
          <stop offset='100%' stopColor={AutumnColors.PUMPKIN} stopOpacity='0' />
        </radialGradient>
      </defs>
      {/* stem */}
      <path d='M22 9c-1-4 1-7 4-8 1 2 0 5-1 8z' fill={AutumnColors.STEM} />
      {/* body segments */}
      <ellipse cx='23' cy='24' rx='21' ry='15' fill={AutumnColors.PUMPKIN_DARK} />
      <ellipse cx='23' cy='24' rx='14' ry='15' fill={AutumnColors.PUMPKIN} />
      <ellipse cx='23' cy='24' rx='7' ry='15' fill={AutumnColors.PUMPKIN_LIGHT} />
      <ellipse cx='23' cy='24' rx='21' ry='15' fill='none' stroke={AutumnColors.PUMPKIN_DARK} strokeWidth='1.2' />
      {lit && (
        <g>
          <ellipse cx='23' cy='24' rx='21' ry='15' fill='url(#autumnPumpkinGlow)' />
          {/* eyes */}
          <path d='M12 20l6 2-6 3z' fill={AutumnColors.GLOW} />
          <path d='M34 20l-6 2 6 3z' fill={AutumnColors.GLOW} />
          {/* nose */}
          <path d='M23 23l2 4h-4z' fill={AutumnColors.GLOW} />
          {/* mouth */}
          <path d='M12 29c3 5 19 5 22 0l-3 1-2-2-3 2-3-2-3 2-3-2-3 2z' fill={AutumnColors.GLOW} />
        </g>
      )}
    </svg>
  );
};

export default AutumnPumpkin;
